export const SUCCESS = 'Success'
